import React, { useState } from "react";
import Select, { SingleValue } from "react-select";
import { Link, useNavigate } from "react-router-dom";
import {
  BellFill,
  BoxArrowLeft,
  GearFill,
  PersonFill,
} from "react-bootstrap-icons";
import { Button, Clock, Dropdown, Tooltip } from "ui";
import classNames from "classnames";
import { useAppDispatch, useAppSelector } from "store";
import { setToken } from "../slice";

import styles from "./dashboard-layout.module.scss";

import { shopAndAcceptor } from "features/account/type";
import { setShopAndAcceptor } from "features/account/slice/shopAndAcceptor";
import { useShopAndAcceptor } from "features/account/api/shop-and-acceptor";

export const Header = ({
  showSidebar,
  SidebarButtonHandler,
}: {
  showSidebar: boolean;
  SidebarButtonHandler: () => void;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const merchantId = useAppSelector((state) => state.merchant.id);
  const [selectedShopAndAcceptor, setSelectedShopAndAcceptor] = useState<
    SingleValue<{
      label: string;
      value: number;
    } | null>
  >(null);
  const { data, isLoading } = useShopAndAcceptor(
    {
      merchantId,
    },
    {
      onSuccess: (res) => {
        if (res.data.length) {
          dispatch(setShopAndAcceptor(res.data[0]));
          setSelectedShopAndAcceptor({
            label: res.data[0].shaparakShop.farsiName,
            value: res.data[0].id,
          });
        }
      },
    }
  );

  const selectOptions = data?.data.map((item) => {
    return {
      label: item.shaparakShop.farsiName,
      value: item.id,
    };
  });
  return (
    <header className={styles.header}>
      <div className="d-flex align-items-center gap-3">
        <div>
          <button
            className={classNames(
              styles.hamburger_button,
              !showSidebar ? styles.active : styles.inactive
            )}
            onClick={SidebarButtonHandler}
          >
            <div></div> <div></div>
            <div></div>
          </button>
        </div>
        <Clock />

        <div
          className={classNames([
            styles.select_shop_container,
            "d-flex align-items-center gap-1",
          ])}
        >
          <label>کسب و کار:</label>
          <Select
            placeholder={"انتخاب کنید"}
            isLoading={isLoading}
            onChange={(e) => {
              setSelectedShopAndAcceptor(e);
              dispatch(
                setShopAndAcceptor(
                  data?.data.find(
                    (item) => item.id === e?.value
                  ) as shopAndAcceptor
                )
              );
            }}
            value={selectedShopAndAcceptor}
            options={selectOptions}
            classNames={{
              control: () => styles.select_control,
              dropdownIndicator: () => styles.dropdownIndicator,
              valueContainer: () => styles.value_container,
              input: () => styles.input,
            }}
          />
        </div>
      </div>

      <div className={styles.icons}>
        <div className="d-flex gap-2">
          <Tooltip title="بروزرسانی ها">
            <Link className="link" to={"/news"}>
              <BellFill size={22} />
            </Link>
          </Tooltip>
          <Tooltip title="تنظیمات">
            <Link className="link" to={"/account"}>
              <GearFill size={22} />
            </Link>
          </Tooltip>
        </div>
        <Dropdown
          menuClass={styles.account_dropdown_menu}
          title={
            <Button variant="secondary">
              <PersonFill size={24} />
            </Button>
          }
        >
          <div>
            <button
              className="button--striped w-100 d-flex gap-2 align-items-center"
              onClick={() => {
                dispatch(setToken(null));
                navigate("/");
              }}
            >
              <BoxArrowLeft className="text-danger" />
              <span>خروج</span>
            </button>
          </div>
        </Dropdown>
      </div>
    </header>
  );
};
